import * as React from "react";
import { HStack, Link, StackProps } from "@chakra-ui/react";
import siteConfig from "configs/site-config";

const Socials = (props: StackProps) => (
  <HStack spacing={1} {...props}>
    {siteConfig.author.accounts.map((account) => (
      <Link
        key={account.url}
        href={account.url}
        isExternal
        aria-label={account.label}
        title={account.label}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        boxSize={9}
        borderRadius="full"
        fontSize="lg"
        color="muted"
        _hover={{ color: "fg", bg: "accentSoft" }}
      >
        {account.icon}
      </Link>
    ))}
  </HStack>
);

export default Socials;
